<template>
  <div class="whr-home-project-class" v-if="dataList.length > 0">
    <div class="title-class">新闻动态</div>
    <el-row class="content-class">
      <el-col :span="wSize.width > 800 ? 8 : 24">
        <div
          class="whr-scale-hover"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-radius: 30px;
            overflow: hidden;
          "
          @click="goToPage(dataList[0])"
        >
          <el-image
            :src="dataList[0].ico"
            alt=""
            fit="cover"
            class="project-page-img"
          >
          <template #placeholder>
                  <div class="image-slot">
                    <el-image
                      class="project-page-img"
                      :src='require("../assets/approve/icon10.jpg")'
                      fit="cover"
                    />
                  </div>
                </template>
            <template #error>
              <div class="image-slot">
                <el-image
                  class="project-page-img"
                  :src='require("../assets/approve/icon10.jpg")'
                  fit="cover"
                />
              </div>
            </template>
          </el-image>
          <el-icon
            class="project-page-icon"
            :size="60"
            color="#fff"
            v-if="isVideoUrl(dataList[0].enclosure)"
            ><icon-view
          /></el-icon>
        </div>
      </el-col>
      <el-col v-if="wSize.width <= 800" :span="24">
        <div style="height: 40px"></div>
      </el-col>
      <el-col :span="wSize.width > 800 ? 16 : 24">
        <div v-for="(item, index) in dataList" :key="index">
          <div class="news-page-title" @click="goToPage(item)">
            <span
              :style="
                wSize.width > 800
                  ? 'margin: 0 40px 0 80px; display: flex'
                  : 'margin: 0; display: flex'
              "
            >
              <span
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  height: 1.5em;
                "
              >
                <span
                  style="font-weight: 600"
                  v-if="item.tags && item.tags !== ''"
                >
                  {{ item.tags }}&nbsp;&nbsp;|&nbsp;
                </span>
                {{ item.title }}
              </span>
            </span>
            <div
              style="
                margin-right: 0;
                margin-left: auto;
                min-width: 100px;
                text-align: right;
              "
            >
              {{ formatTimestampToDate(item.createTime) }}
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script setup>
import useUserStore from "@/store/module/user";
const goToPage = (item) => {
  const userStore = useUserStore();
  userStore.changeScode({ scode: item.scode, id: item.id });
};
</script>
<script>
import { useWindowSize } from "@vueuse/core";
// import router from "../router";
import { VideoPlay as IconView } from "@element-plus/icons-vue";
import { MenuApi } from "@/api/nav";
import { common } from "@/common";

const getContentList = async (params) => {
  const data = await MenuApi.getContentList(params);
  return data.data;
};
export default {
  components: {
    IconView,
  },
  data() {
    return {
      wSize: useWindowSize(),
      dataList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    handleError() {
      console.log('图片加载失败');
    },
    isVideoUrl(enclosure) {
      return common.isVideoUrl(enclosure);
    },
    formatTimestampToDate(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    getData() {
      getContentList({
        scodes: "4-1,4-2,4-3",
        pageNo: 1,
        pageSize: 7,
        istop: '1'
      }).then((data) => {
        if (data) {
          //   const groups = [];
          //   for (let i = 0; i < data.list.length; i += 2) {
          //     groups.push(data.list.slice(i, i + 2));
          //   }
          this.dataList = data.list;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.whr-home-project-class {
  background-color: #fff;
  padding: 40px var(--padding);
  .title-class {
    font-size: 3vw;
    text-align: left;
    width: fit-content;
    border-bottom: 7px solid var(--primaryColor);
  }
  @media screen and (max-width: 800px) {
    // padding: 40px 10%;
    .title-class {
      font-size: 5vw;
    }
  }
  .content-class {
    margin-top: 40px;
  }
  .project-page-img {
    //   width: 419px;
    width: 100%;
    height: 240px;
    // margin: 0 10%;
    
  }
  .project-page-icon {
    position: absolute;
  }
  .news-page-title {
    font-size: 18px;
    height: 30px;
    line-height: 30px;
    text-align: left;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin: 4px 0;
  }
  .news-page-title:hover {
    color: var(--primaryColor);
  }
}
</style>
